import { createFileRoute } from '@tanstack/react-router';
import { GoalsRoute } from './-goals-route';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/')({
  component: GoalsRoute,
});
